export default __webpack_public_path__ + "static/media/Carrefour.c094ed11.svg";